import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [{ title: "menu_sidebar_management" }, { title: "menu_sidebar_coupon", link: "/management/coupons" }];

const Coupons = Loadable({
  loader: () => import("container/coupons"),
  loading() {
    return <Loader />;
  }
});

const CouponDetail = Loadable({
  loader: () => import("container/coupons/add"),
  loading() {
    return <Loader />;
  }
});

export const couponRoutes: IRoute[] = [
  {
    path: "/management/coupons",
    element: <Coupons />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "/management/coupons/details",
    element: <CouponDetail />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  }
];
